import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmailService {

  baserApiUrl:string=environment.baseApi
  constructor(public http:HttpClient) { }

  getEmailLog(filter:any){
    return this.http.get(`${this.baserApiUrl}email?${filter}`)
  }

  getEmailCliente(filter:any){
    return this.http.get(`${this.baserApiUrl}email-cliente?${filter}`,)
  }

  addEmailCliente(data:any){
    return this.http.post(`${this.baserApiUrl}email-cliente`,data)
  }
}
